import { getOr } from 'lodash/fp';
import { resolveImageUrl } from '@/utils/resolvers';

export const parseEsTabbedContentCardResults = (resultItems: any[], page: any): CardType[] => {
  const getRaw = (field: string, defaultValue = '') => getOr(defaultValue, [field, 'raw']);
  return resultItems.map((resultItem: any) => ({
    ...resultItem,
    cardHeading: getRaw('title')(resultItem),
    cardDescription: getRaw('description')(resultItem),
    url: getRaw('url')(resultItem),
    cardImage: {
      original: {
        url: resolveImageUrl({ raw: getRaw('image')(resultItem) }),
      },
    },
    cardCategory: getRaw('title')(resultItem),
  }));
};
